import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppleReenrollmentsComponent } from './components/apple-reenrollments/apple-reenrollments.component';
import { authToken } from '../guards/auth-token.guard';
import { requiredPrivilege } from '../guards/required-privilege.guard';

const routes: Routes = [
  { path: 'apple-reenrollments', component: AppleReenrollmentsComponent, canActivate: [authToken, requiredPrivilege], 
      data: { privilege: 'PRIV_WR_RPT' }
  },
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule { }
